import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import GatePasses from './routes/GatePasses';
import ExamInsights from './routes/ExamInsights';
import ExamInsightsPrints from './routes/ExamInsights/routes/ExamInsightsPrints';
import ExamAiInsights from './routes/ExamAiInsights';

const InsightsLazy = React.lazy(
	() => import(/* webpackChunkName : 'Insights' */ './components')
);

export default (store) => [
	{
		path: 'home/insights',
		element: <AsyncLoading component={<InsightsLazy />} />,
		children: [
			{
				index: true,
				element: <Navigate to="gate-passes" replace />,
			},
			...GatePasses(store),
			...ExamInsights(store),
		],
	},
	...ExamInsightsPrints(store),
	...ExamAiInsights(store),
];
